import type * as Types from 'app/types/graphql';

export type ClickMapPointSelectFragment = Pick<
  Types.ClickMapPoint,
  'hash' | 'elementSelector' | 'x' | 'y' | 'clicks' | 'points' | 'totalClicks'
>;

export const ClickMapPointSelectFragmentDoc = `
    fragment ClickMapPointSelect on ClickMapPoint {
  hash
  elementSelector
  x
  y
  clicks
  points
  totalClicks
}
    `;
